import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Pour rediriger

function FormulaireInscription() {
  const [classes, setClasses] = useState([]);
  const [eleves, setEleves] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedEleve, setSelectedEleve] = useState('');
  const [clubId, setClubId] = useState('');
  const [membres, setMembres] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentMember, setCurrentMember] = useState(null);
  const navigate = useNavigate();

  // Vérifier si l'utilisateur est connecté
  useEffect(() => {
    const token = localStorage.getItem('token'); // Récupère le token depuis le localStorage
    if (!token) {
      navigate('/connexion'); // Redirige vers la page de connexion si pas de token
    } else {
      const clubData = JSON.parse(atob(token.split('.')[1])); // Décodage basique du token JWT
      setClubId(clubData.id); // Utilise l'ID du club connecté
    }
  }, [navigate]);

  // Charger les classes depuis le backend
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get('http://54.36.103.84:5000/api/classes');
        setClasses(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des classes', error);
      }
    };
    fetchClasses();
  }, []);

  // Charger les élèves en fonction de la classe sélectionnée
  useEffect(() => {
    const fetchEleves = async () => {
      if (selectedClass) {
        try {
          const response = await axios.get(`http://54.36.103.84:5000/api/eleves/${selectedClass}`);
          setEleves(response.data);
        } catch (error) {
          console.error('Erreur lors de la récupération des élèves', error);
        }
      }
    };
    fetchEleves();
  }, [selectedClass]);

  // Charger les membres du club avec le token
  useEffect(() => {
    const fetchMembres = async () => {
      if (clubId) {
        const token = localStorage.getItem('token'); // Récupère le token
        try {
          const response = await axios.get(`http://54.36.103.84:5000/api/clubs/Membres/${clubId}`, {
            headers: {
              Authorization: `Bearer ${token}` // Inclut le token dans l'en-tête
            }
          });
          setMembres(response.data);
        } catch (error) {
          console.error('Erreur lors de la récupération des membres', error);
          if (error.response && error.response.status === 401) {
            alert('Session expirée. Veuillez vous reconnecter.'); // Message d'erreur pour une session expirée
            navigate('/connexion'); // Redirige vers la page de connexion
          }
        }
      }
    };
    fetchMembres();
  }, [clubId, navigate]);

  // Gérer la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérification des sélections
    if (!selectedClass || !selectedEleve) {
      alert("Veuillez sélectionner une classe et un élève.");
      return;
    }

    const data = {
      Id_Eleves: selectedEleve,
      Id_Clubs: clubId // Utilise l'ID du club connecté
    };

    try {
      const response = await axios.post('http://54.36.103.84:5000/api/eleves_clubs', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}` // Inclut le token dans l'en-tête
        }
      });

      if (response.status === 200) {
        alert('Inscription au club réussie');
        setSelectedEleve(''); // Réinitialiser la sélection
      } else {
        alert('Échec de l\'inscription');
      }
    } catch (error) {
      console.error('Erreur lors de l\'inscription au club', error);
      if (error.response && error.response.status === 409) {
        alert(error.response.data.message); // Message d'erreur spécifique
      } else {
        alert('Erreur lors de l\'inscription');
      }
    }
  };

  // Fonction pour éditer un membre
  const handleEditMember = (member) => {
    setCurrentMember(member);
    setSelectedClass(member.Classe_Eleves); // Préremplir avec les données du membre
    setSelectedEleve(member.Id_Eleves);
    setIsEditing(true);
  };

  // Gérer la mise à jour du membre
  const handleUpdateMember = async (e) => {
    e.preventDefault();
    // Logique pour mettre à jour le membre ici
    // Vous pouvez appeler l'API correspondante pour mettre à jour les détails du membre

    alert('Membre mis à jour avec succès');
    setIsEditing(false); // Fermer le formulaire d'édition
    setCurrentMember(null); // Réinitialiser le membre en cours
  };

  return (
    <div className="container">
      <h4 className="text-center mb-30">Inscription d'un nouveau membre</h4>
      <form className="contact-form text-center mb-80" onSubmit={handleSubmit}>
        {/* Sélection de la classe */}
        <div className="row mb-3">
          <label htmlFor="classe" className="form-label col-12 text-center">Sélectionner la Classe</label>
          <div className="col-6 mx-auto">
            <select
              id="classe"
              className="form-control"
              value={selectedClass}
              onChange={(e) => {
                setSelectedClass(e.target.value);
                setSelectedEleve(''); // Réinitialise la sélection d'élève
                setEleves([]); // Réinitialise la liste des élèves
              }}
            >
              <option value="">Choisir une classe...</option>
              {classes.map((classe) => (
                <option key={classe.Id_Classe} value={classe.Id_Classe}>
                  {classe.Id_Classe}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Sélection de l'élève */}
        <div className="row mb-3">
          <label htmlFor="eleve" className="form-label col-12 text-center">Sélectionner l'Élève</label>
          <div className="col-6 mx-auto">
            <select
              id="eleve"
              className="form-control"
              value={selectedEleve}
              onChange={(e) => setSelectedEleve(e.target.value)}
            >
              <option value="">Choisir un élève...</option>
              {eleves.map((eleve) => (
                <option key={eleve.Id_Eleves} value={eleve.Id_Eleves}>
                  {eleve.Prenom_Eleves} {eleve.Nom_Eleves} {eleve.Classe_Eleves}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Bouton de soumission */}
        <button type="submit" className="btn-style-1 mb-3 col-5 mx-auto">Enregistrer</button>
      </form>

      {/* Section des membres */}
      <h4 className="text-center mb-30">Membres Inscrits</h4>
      <div className="row">
        {membres.map((member) => (
          <div className="card col-4 mx-auto mb-3" key={member.Id_Eleves}>
            <div className="card-body">
              <h5 className="card-title">{member.Prenom_Eleves} {member.Nom_Eleves}</h5>
              <button className="btn btn-secondary" onClick={() => handleEditMember(member)}>Éditer</button>
            </div>
          </div>
        ))}
      </div>

      {/* Formulaire d'édition pour le membre */}
      {isEditing && (
        <form className="contact-form text-center mb-80" onSubmit={handleUpdateMember}>
          <h4 className="text-center mb-30">Éditer le Membre</h4>
          <div className="row mb-3">
            <label htmlFor="eleveEdit" className="form-label col-12 text-center">Nom de l'Élève</label>
            <div className="col-6 mx-auto">
              <input
                type="text"
                id="eleveEdit"
                className="form-control"
                value={selectedEleve} // Remplir avec l'ID de l'élève
                readOnly
              />
            </div>
          </div>

          <button type="submit" className="btn-style-1 mb-3 col-5 mx-auto">Mettre à jour</button>
          <button type="button" className="btn btn-danger mb-3 col-5 mx-auto" onClick={() => setIsEditing(false)}>Annuler</button>
        </form>
      )}
    </div>
  );
}

export default FormulaireInscription;
